import { FC } from 'react';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { furtherCased, formatLabel } from 'helpers/kyc/text-formatting';
import RecordRow from './RecordRow';

const StyledLink = styled(Link)({
  color: blue[500],
  textDecoration: 'underline',
  cursor: 'pointer',
  fontWeight: 'normal',
});

type Props = {
  data: Array<{
    name: string;
    value: string;
    snippet?: string;
  }>;
  type: string;
  index: number;
};

const SanitizedHitDataDisplay: FC<Props> = ({ data, type, index }) => {
  return (
    <>
      {data.map((item) => (
        <RecordRow
          key={`${type}-${index}-${item.name}`}
          label={formatLabel(item.name)}
        >
          {item.name.toLowerCase().includes('url') &&
          item.value.toLowerCase().startsWith('http') ? (
            <StyledLink
              href={item.value}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.value}
            </StyledLink>
          ) : (
            furtherCased(item.value)
          )}
        </RecordRow>
      ))}
    </>
  );
};

export default SanitizedHitDataDisplay;
